<script>
  import { onMount } from "svelte";
  export let scale
  export let forms = 50

  /* Calculations */
  $: contactSales = forms > 1_000_000
  let calcScale
  $:{
    // For calculation, scale must be sorted highest volume first
    calcScale = scale ? [...scale] : [];
    calcScale.sort((a,b)=>b.gt - a.gt)
  }

  function totalPrice(count){
    return calcScale.reduce((memo, rule)=>{
      const [price, remaining] = memo;
      return remaining <= rule.gt
        ? memo
        : [price + (remaining - rule.gt) * rule.each, rule.gt]
    }, [0, count])[0];
  }

  function averagePrice(count){
    return (totalPrice(count) / (count || 1)) || 0;
  }

  /*
   * Focus the input on page load (actually on component mount), but only if the user
   * hasn't scrolled past it already, e.g., when visiting an anchor or using back/fwd.
   */
  let inputToFocus
  onMount(()=>{
    if(inputToFocus.getBoundingClientRect().bottom > 0) inputToFocus.focus();
  })
</script>

<section>
  <h2 class="price-calc">Pricing Calculator</h2>
  <table>
    <thead>
      <tr>
        <th width="60%"><label for="form-count">
          How many total 1099, W-2,<br>
          1095, 1042-S, T4A &amp; 94x forms?
        </label></th>
        <th width="40%">{#if !contactSales}Average price per form:{/if}</th>
      </tr>
      <tr>
        <td>
          <input id="form-count" class="form-control" maxlength="6" bind:value={forms} bind:this={inputToFocus}>
        </td>
        <td>
          {#if contactSales}
            <a href="https://www.avalara.com/us/en/get-started.html" class="btn btn-lg btn-ava-primary d-block">Contact Sales</a>
          {:else}
            <output for="form-count">${averagePrice(forms).toFixed(2)} <span>each</span></output>
          {/if}
        </td>
      </tr>
    </thead>
    <tbody>
      {#each scale as line}
        <tr>
          <td>{line.label}</td>
          <td>${(1 * line.each).toFixed(2)} each</td>
        </tr>
      {/each}
    </tbody>
  </table>
</section>

<style>
  section {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    padding: 15px;
    overflow: hidden;
    max-width: 600px;
  }

  h2.price-calc {
    font-size: 28px;
    margin: 0 0 12px;
    font-weight: bold;
  }

  table {
    margin: 0;
    table-layout: fixed;
    width: 100%;
  }

  tr>*:first-child {
    padding-right: 15px;
  }
  tr>*:last-child {
    padding-left: 15px;
  }
  th {
    vertical-align: bottom;
    font-weight: 500;
  }
  thead td {
    padding-bottom: 15px;
  }

  label {
    /* Bootstrap 'reboot' has very specific ideas about the use of labels */
    margin: 0;
    display: inline;
    font-weight: inherit;
  }
  input {
    box-shadow: none;
    border-radius: 2px;
    font-size: 30px;
    line-height: 50px;
    height: 50px;
  }

  output {
    display:block;
    font-size: 30px;
    border-radius: 2px;
    line-height: 50px;
    height: 50px;
    color: #fff;
    background-color: #54b44f;
    padding: 0 10px;
    overflow: hidden;
  }
  output > span {
    font-size: 20px;
  }

  tbody {
    border-top: 1px solid #c1c1c1;
    color: #424242;
  }
  tbody tr:nth-child(odd) {
    background-color: #f7f7f7;
  }
  tbody td {
    line-height: 35px;
    padding-left: 10px;
  }
  tbody td:last-child {
    padding-left: 25px;
  }
</style>